import request from '@/utils/request'
const platform = localStorage.getItem('platform')

export function getPromotions(data) {
    const url = `/${platform}/promotion/${data.id}/index`
    return request.get(url)
}

export function getPromotionReports(data) {
    const url = `/${platform}/promotion/${data.advertiser_id}/reports`
    delete data.advertiser_id
    return request.post(url, data)
}

export function updatePromotionByField(data) {
    const url = `/${platform}/promotion/${data.advertiser_id}/update`
    delete data.advertiser_id
    return request.patch(url, data)
}

export function storePromotion(data) {
    const url = `/${platform}/promotion`
    return request.post(url, data)
}

export function copyPromotion(data) {
    const url = `/${platform}/promotion/${data.advertiser_id}/copy`
    return request.post(url, data)
}

export function getYjql(data) {
    const url = `/${platform}/promotion/${data.advertiser_id}/yjql`
    return request.get(url, data)
}

export function updateYjql(data) {
    console.log(data)
    const url = `/${platform}/promotion/${data.advertiser_id}/update_yjql`
    return request.post(url, data)
}

export function deletePromotion(data) {
    const url = `/${platform}/promotion/${data.advertiser_id}/destroy`
    return request.post(url, data)
}